export default "<p>base-date-range-selector works!</p>\r\n";